var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWelcomeL(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 202,
    viewBox: "0 0 105 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 50.5C30.5 49.5 60.5 120 35.5 120C13.0445 120 29.5 75.5 5 50.5Z",
    fill: "url(#paint0_linear_1477_4259)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0C66 5.99997 71.5 124.5 54.5 124.5C27.5 124.5 52.5 27 17.5 0Z",
    fill: "url(#paint1_linear_1477_4259)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7554 12.5C75.0279 31 85.2688 122 71.5955 122C48.0954 122 63.0955 24.5 91.7554 12.5Z",
    fill: "url(#paint2_linear_1477_4259)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5 144.812C97.5 166.506 93.6522 180.653 86.158 189.379C78.6819 198.084 67.4827 201.5 52.5 201.5C37.5327 201.5 26.5827 197.664 19.351 188.746C12.0979 179.803 8.5 165.649 8.5 144.812C8.5 132.93 8.50096 124.734 9.1916 119.096C9.88331 113.45 11.2491 110.546 13.8159 109.037C15.1188 108.272 16.7762 107.836 18.9124 107.63C21.0488 107.423 23.6272 107.448 26.7529 107.577C28.4138 107.645 30.2262 107.742 32.202 107.848C37.645 108.141 44.3282 108.5 52.5 108.5C60.8548 108.5 67.6872 108.141 73.2524 107.848C75.2728 107.742 77.1262 107.645 78.8248 107.577C82.0208 107.448 84.6584 107.423 86.8445 107.63C89.0306 107.837 90.7283 108.272 92.0633 109.04C94.6911 110.551 96.0861 113.454 96.7929 119.098C97.499 124.735 97.5 132.93 97.5 144.812Z",
    fill: "#F8F8F8",
    stroke: "#2A2B3A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2864 188.5C97.8614 188.5 98.3129 188.833 98.4146 189.288C98.7993 191.008 97.8704 192.627 95.591 194.146C93.3189 195.661 89.8411 196.97 85.5123 198.046C76.8676 200.194 64.9968 201.371 53.0564 201.49C41.1158 201.609 29.1473 200.668 20.3064 198.601C15.8806 197.567 12.2786 196.259 9.85794 194.687C7.43369 193.112 6.3051 191.355 6.52787 189.415C6.58629 188.907 7.0822 188.5 7.72462 188.5L97.2864 188.5Z",
    fill: "#F8F8F8",
    stroke: "#2A2B3A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 145.706C72.5 143.118 68.5 148.706 56.5 145.706C51.1824 144.376 41 145.706 41 145.706",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67 151.906C60.5 154.279 53.5107 148.982 43.5 151.906C38.8012 153.279 33 151.906 33 151.906",
    stroke: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1477_4259",
    x1: 1,
    y1: 63,
    x2: 57.3164,
    y2: 72.1004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79F1A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E5CAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1477_4259",
    x1: 17,
    y1: 46,
    x2: 76.9119,
    y2: 48.4737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79F1A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E5CAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1477_4259",
    x1: 60,
    y1: 12.5,
    x2: 112.929,
    y2: 28.9197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79F1A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E5CAD"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeL);
export default __webpack_public_path__ + "static/media/welcome-l.1338a6db6aa359b8d7faa489dd75be58.svg";
export { ForwardRef as ReactComponent };